import { render, staticRenderFns } from "./BancaFarmaciListPage.vue?vue&type=template&id=d8f2e676"
import script from "./BancaFarmaciListPage.vue?vue&type=script&lang=js"
export * from "./BancaFarmaciListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports